module.exports = __webpack_public_path__ + "static/media/menu-graphic.04b4426b.svg";